import React, { useEffect } from 'react'
import { Link, useRouteError } from 'react-router-dom'

import Button from './design/Button'
import Heading from './design/Heading'
import Paragraph from './design/Paragraph'

const ErrorRouteNotFound: React.FC = () => {
    useEffect(() => {
        document.getElementById('root-spinner')?.remove()
    }, [])

    const error = useRouteError() as { status?: number; statusText?: string; message?: string }
    const is404 =
        error.status === 404 ||
        (error instanceof Error && error.message.includes('No route matches URL'))

    const heading = is404 ? '404: Page Not Found' : 'An Error Occurred'
    const friendlyMessage = is404
        ? "Sorry, we couldn't find the page you're looking for."
        : "We're sorry, but something went wrong. Please try again later."

    return (
        <div className="flex h-screen flex-col items-center justify-center">
            <Heading size="xl" className="mb-4">
                {heading}
            </Heading>
            <Paragraph className="mb-8">{friendlyMessage}</Paragraph>
            {!is404 && (
                <Paragraph className="mb-8 text-red-500">
                    {error instanceof Error ? error.message : 'Unknown error'}
                </Paragraph>
            )}
            <Link to="/">
                <Button intent="primary">Go Home</Button>
            </Link>
        </div>
    )
}

export default ErrorRouteNotFound
